import { render, staticRenderFns } from "./ItemMasterDetailsSection.vue?vue&type=template&id=3443c8ee&scoped=true&"
import script from "./ItemMasterDetailsSection.vue?vue&type=script&lang=js&"
export * from "./ItemMasterDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./ItemMasterDetailsSection.vue?vue&type=style&index=0&id=3443c8ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3443c8ee",
  null
  
)

export default component.exports